export default [
    {
        path: '/vehicles',
        name: 'Company / Vehicles',
        component: () => import('@/views/pages/vehicles'),
        meta:
        {
            page: 'list',
        },
        children:
        [
            {
                path: 'overview',
                name: 'Company / Vehicle Overview',
                component: () => import('@/views/pages/vehicles'),
                meta:
                {
                    page: 'overview',
                    subPage: 'main',
                },
            },
            {
                path: ':code',
                name: 'Company / View Vehicle',
                component: () => import('@/views/pages/vehicles'),
                meta:
                {
                    page: 'view',
                },
            },
        ],
    },
];